import {HubConnectionBuilder, LogLevel} from '@microsoft/signalr';

import config from '~/configuration';
import authentication from '~/lib/authentication';
import trace from '~/lib/trace';
import handler from '~/lib/notifications/handler';

const initialize = async () => {
  trace('Initializing notifications');
  const user_id = await authentication.getUserID();

  if (!user_id) {
    setTimeout(initialize, 60 * 1000); // User id not found, retry after 1 minute.
    return;
  }

  const token = await authentication.getAutoRefreshAccessToken();

  const connection = new HubConnectionBuilder()
    .withUrl(config.signalRHubUrl + '/lessor/notification', {
      headers: {
        'x-ms-client-principal-id': user_id,
      },
      accessTokenFactory: () => token,
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Information)
    .build();

  connection.on('notification', (notification) => {
    try {
      trace('Notification received', notification);

      handler(notification);
    } catch (e) {
      console.log(e);
    }
  });
  connection.onclose(() => {
    console.log('Notifications disconnected');
    alert(
      'Verbinding met notificaties verbroken, de applicatie zal nu worden herstart.',
    );
    window.location.reload();
  });

  console.log('connecting...');
  await connection.start();
};

export default {
  initialize,
  kill: () => {
    // Notifications kill method stub
  },
  register: async () => {
    await initialize();
  },
  requestPermissions: async () => {
    try {
      const result = await Notification.requestPermission();
      trace('Permission result', result);
    } catch {}
  },
};
